<div class="flex-container">
  <div class="form-outter">
    <card-component>
      <card-content>
        <div class="login">
          <img id="profile-img" alt="logo" class="profile-img-card" src="images/logo.png" />
          @if (showChallenge) {
						<two-factor-challenge [loginSuccessful]="redirect"></two-factor-challenge>
          } @else {
						<login-form [loginSuccessful]="redirect" [displayRegister]="true" [showChallenge]="displayChallengeScreen"></login-form>
          }
        </div>
      </card-content>
    </card-component>
  </div>
</div>


